<template>
  <FlexColumn :space="0">
    <Button
        v-if="applicant.chatRequest == null"
        color="primary"
        :disabled="!enabled"
        @click="handleClick"
    >
      スカウト
    </Button>

    <Button
        v-if="applicant.chatRequest"
        :ripple="false"
        color="primary"
        outlined
        style="cursor: auto"
    >
      <v-icon size="21" class="mr-1">mdi-check</v-icon>
      送信しました
    </Button>

    <MessageDialog :open="messageDialog" @ok="messageDialog=false">
      スカウトの送信可能数は40件/月です。これ以上送信したい場合は、Nishikaにご相談ください
    </MessageDialog>
  </FlexColumn>
</template>

<script>
import ApiMixin from "@/ApiMixin";
import {mapGetters} from "vuex";
import MessageDialog from "./MessageDialog";
import Button from '../atoms/Button'
import FlexColumn from '../atoms/FlexColumn'

export default {
  mixins: [ApiMixin],
  name: "ChatRequestButton",
  components: { FlexColumn, Button, MessageDialog },
  props: {
    jobId: {
      type: String
    },
    requestorId: {
      type: String
    },
    applicant: {
      type: Object
    },
    reasons: {
      type: Array
    }
  },
  data() {
    return {
      messageDialog: false
    }
  },
  computed: {
    ...mapGetters("client", ["company"]),
    ...mapGetters('chatRequests', ['tickets']),
    enabled() {
      return this.applicant.chatRequest == null && this.reasons.length > 0
    }
  },
  methods: {
    handleClick() {
      if (this.tickets.free > 0) {
        this.sendChatRequest(this.company.id, this.requestorId, this.jobId, this.applicant.id, this.reasons)
      } else {
        this.messageDialog = true
      }
    }
  }
}
</script>

<style scoped>

</style>
